import config from '@/utils/configUtil'
const context = config().VUE_APP_ROOT_API

export default {
  status: '',
  // permissions: [],
  // loggingIn: null,
  // accountId: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accountId : '',
  organizationId: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).organizationId : '',
  organizationUserId: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).organizationUserId : '',
  organizationPlanStatus: undefined,
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : '',
  userAvatar: localStorage.getItem('user')
    ? `${context}user/api/v1.0/user/profile/${JSON.parse(localStorage.getItem('user')).id}/image/icon?v=1`
    : '',
  avatarVersion: 0,
  message: null,
  newRegister: {
    userId: null,
    organizationId: null,
  },
  session: {
    user: null,
    organization: null,
    permissions: [],
    salesManager: {
      name: null
    },
    features: [],
  },
}
